/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {AdobeIMS} from '@identity/imslib/adobe-ims/AdobeIMS';
import {getIMSConfig} from '@exc/core/src/utils/IMSConfig';

/* eslint-disable sort-keys */
const ENVS = {
  test: 'stg1',
  dev: 'stg1',
  qa: 'stg1',
  stage: 'stg1',
  prod: ''
};
/* eslint-enable sort-keys */

const storedEvents = [];

function getEnv(environment) {
  const url = new URL(window.location.href);
  if (url.searchParams.has('shell_ims')) {
    return url.searchParams.get('shell_ims');
  }
  return environment.toLowerCase() === 'prod' ? 'prod' : 'stage';
}

export function initIMS() {
  window.performance.mark('us_start');

  const env = getEnv((window.config || {}).env);
  const config = getIMSConfig(ENVS[env]);

  window['exc-ims-error-handler'] = error => {
    // If an error is thrown before Auth.js has time to replace the error handler, we add it to the storedEvents
    // so it can be handled after the new function is assigned to onError.
    storedEvents.push('auth.error');
    document.dispatchEvent(new CustomEvent('auth.error', {error}));
  };

  let adobeid = Object.assign({}, config, {
    isFromIMS: window.location.hash.indexOf('from_ims') > -1,
    locale: window.navigator.language,
    onAccessToken: token => document.dispatchEvent(new CustomEvent('auth.accesstoken', {token})),
    onAccessTokenHasExpired: () => {
      storedEvents.push('auth.accesstokenexpired');
      document.dispatchEvent(new CustomEvent('auth.accesstokenexpired', {}));
    },
    onError: err => window['exc-ims-error-handler'](err),
    optimizations: {fastEvents: true},
    storedEvents
  });
  let adobeIMS;

  window['exc-ims'] = new Promise(resolve => {
    adobeid.onReady = resolve;
    adobeIMS = new AdobeIMS(adobeid);
    adobeIMS.initialize();
  }).then(() => {
    return {adobeid, adobeIMS};
  }).catch(error => {
    // eslint-disable-next-line no-console
    console.warn(`Init error: ${error.message}`);
  });
}
